export default __webpack_public_path__ + "static/media/keyboardDownIcon.348e85bb.svg";